import { CsvExportUtils, JsonExportUtils, XlsxExportUtils } from "@stellar/utils";
import { ExportFormat } from "@utils/file-data-export";

export async function exportDataByFormat<
  T extends Record<string, string | number | null | undefined>
>({
  data,
  fileName,
  format,
}: {
  data: T[];
  fileName: string;
  format: ExportFormat;
}): Promise<void> {
  switch (format) {
    case "CSV":
      CsvExportUtils.toFileDownload(data, `${fileName}.csv`);
      return;

    case "XLSX":
      await XlsxExportUtils.convertFileToXlsx({
        data,
        fileName,
      });
      return;

    case "JSON":
      JsonExportUtils.exportData({
        data,
        fileName,
      });
      return;

    default:
      throw new Error(`Unsupported format: ${format}`);
  }
}
